import Hero from "../components/Hero";
import { Link } from "react-router-dom";
import "./AboutMe.css";

const timelineData = [
  {
    roleTitle: "Motion Graphic Designer",
    company: "ThinkMarkets",
    companyUrl: "https://www.thinkmarkets.com",
    date: "Jan 2024 – Present (Hybrid)",
    about:
      "Designing animated finance-related visuals and video explainers that boosted brand engagement by 30%. Collaborating with marketing and product teams to craft compelling narrative-driven motion pieces.",
  },
  {
    roleTitle: "Motion Graphic Designer",
    company: "Hoody",
    companyUrl: "https://hoody.com",
    date: "Sep 2023 – Nov 2023 (On-site)",
    about:
      "Produced high-impact social media ads and in-store loop animations, learning to streamline pipelines under fast turnaround times and tight brand guidelines.",
  },
  {
    roleTitle: "Motion Graphic Designer",
    company: "Cointelegraph",
    companyUrl: "https://cointelegraph.com",
    date: "Mar 2022 – Jan 2023 (Full-remote)",
    about:
      "Delivered daily crypto news pieces and cinematic brand videos for third-party clients—including projects tied to Snoop Dogg—refining rapid prototyping and blockchain-focused storytelling. Advanced 3D and compositing skills using Blender and After Effects to craft visually compelling, narrative-driven content.",
  },
  {
    roleTitle: "Motion Graphic Designer",
    company: "Astranova",
    companyUrl: "https://astranova.com",
    date: "Sep 2022 – Jan 2023 (Part-time Remote)",
    about:
      "Developed cinematic product demos and brand videos for tech clients, expanding my compositing and 3D texturing expertise in Blender and After Effects.",
  },
  {
    roleTitle: "Motion Graphic Designer",
    company: "ImagineContent",
    companyUrl: "https://imaginecontent.com",
    date: "Jan 2021 – Feb 2022 (Remote)",
    about:
      "Led full video production cycles for product and service clients, enhancing engagement and streamlining delivery through reusable templates. Refined workflows in After Effects and Premiere Pro while supporting the team with creative problem-solving.",
  },
  {
    roleTitle: "Freelance",
    company: "",
    companyUrl: "",
    date: "Mar 2017 – Present",
    about:
      "Collaborated with diverse clients to produce custom motion graphics and marketing videos, significantly boosting video CTR by 35%, cutting production time by 40% with reusable templates, and assisting teammates with complex tasks.",
  },
];

export default function AboutMe() {
  return (
    <>
      <Hero
        title="About me"
        subtitle="Motion Graphic Designer"
        mediaType="video"
        mediaSrc="../assets/hero-video-particles-3.webm"
      >
        <div className="hero-buttons">
          <Link to="/personal" className="hero-button-primary">
            Personal
          </Link>
          <Link to="/portfolio" className="hero-button-secondary">
            Portfolio
          </Link>
        </div>
      </Hero>

      <div className="container about-page">
        <section className="about-content">
          {/* Main content */}
          <div className="main-column">
            <h2 className="section-title">Who am I exactly?</h2>
            <p className="lead">
              A skilled motion designer with extensive experience in creating
              video content for various platforms.
            </p>

            <div className="profile-pic mobile-only">
              <img src="/assets/profile-pic.webp" alt="George Sotirov" />
            </div>

            <h2 className="section-title">George Sotirov</h2>
            <p>
              I collaborate with brands, agencies, and creators to produce
              motion graphics that stand out. Whether it’s animated ads, video
              intros, or cinematic sequences, I help turn concepts into visually
              stunning realities.
            </p>

            <hr />

            <div className="timeline">
              {timelineData.map((item, idx) => (
                <div key={idx} className="timeline-item">
                  <h4>
                    {item.roleTitle}
                    {item.company && (
                      <>
                        {" "}
                        @{" "}
                        <a
                          href={item.companyUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.company}
                        </a>
                      </>
                    )}
                  </h4>
                  <span className="date">{item.date}</span>
                  {item.about && <p className="about">{item.about}</p>}
                </div>
              ))}
            </div>

            {/* Mobile-only widgets */}
            <div className="widget mobile-only">
              <h3>Contact</h3>
              <ul>
                <li>Sofia, Bulgaria</li>
                <li>gsotirovamp@gmail.com</li>
                <li>+359 896 898 879</li>
              </ul>
            </div>

            <div className="widget mobile-only">
              <h3>Skills</h3>
              <ul>
                <li>Motion Design</li>
                <li>Graphic Design</li>
                <li>3D &amp; 2D Animation</li>
                <li>Modeling · Texturing · UV</li>
                <li>Editing &amp; Post Production</li>
                <li>VFX · Compositing</li>
                <li>Web Design</li>
                <li>HTML, CSS, JS, Python</li>
              </ul>
            </div>

            <div className="widget mobile-only">
              <h3>Expertise</h3>
              <ul>
                <li>After Effects</li>
                <li>Blender</li>
                <li>DaVinci Resolve</li>
                <li>Creative Cloud</li>
                <li>Figma</li>
                <li>Rive</li>
              </ul>
            </div>

            <a
              href="assets/George_Sotirov_CV_Q3.pdf"
              className="btn-download"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a>
          </div>

          {/* Sidebar (desktop-only) */}
          <aside className="sidebar desktop-only">
            <div className="profile-pic">
              <img src="/assets/profile-pic.webp" alt="George Sotirov" />
            </div>

            <div className="widget">
              <h3>Contact</h3>
              <ul>
                <li>Sofia, Bulgaria</li>
                <li>gsotirovamp@gmail.com</li>
                <li>+359 896 898 879</li>
              </ul>
            </div>

            <div className="widget">
              <h3>Skills</h3>
              <ul>
                <li>Motion Design</li>
                <li>Graphic Design</li>
                <li>3D &amp; 2D Animation</li>
                <li>Modeling · Texturing · UV</li>
                <li>Editing &amp; Post Production</li>
                <li>VFX · Compositing</li>
                <li>Web Design</li>
                <li>HTML, CSS, JS, Python</li>
              </ul>
            </div>

            <div className="widget">
              <h3>Expertise</h3>
              <ul>
                <li>After Effects</li>
                <li>Blender</li>
                <li>DaVinci Resolve</li>
                <li>Creative Cloud</li>
                <li>Figma</li>
                <li>Rive</li>
              </ul>
            </div>
          </aside>
        </section>
      </div>
    </>
  );
}
